import React from "react";
import TelecomMasters from "./TelecomMasters";
import TelecomSuperMasters from "./TelecomSuperMasters";
import ZoomTable from "./ZoomTable";
import Meetings from "./MeetingsTable";
import RefundsTable from "./RefundsTable";
import ManagerTable from "./ManagersTable";
import TransactionsTable from "./TransactionsTable";
import OwnerTable from "./OwnerTable";
import HostTable from "./HostTable";
import HostsTable from "./HostsTable";
import AllUsersTable from "./AllUsersTable";
import Zoom from "./Zoom";

const DContent = ({ activeTab }) => {
  const renderContent = () => {
    switch (activeTab) {
      case "managers":
        return <ManagerTable />;
      case "all_users":
        return <AllUsersTable />;
      case "refunds":
        return <RefundsTable />;
      case "telecom_super_masters":
        return <TelecomSuperMasters />;
      case "telecom_masters":
        return <TelecomMasters />;
      case "cutting_meetings":
        return <Meetings />;
      case "cutting_zoom":
        return <ZoomTable />;
      case "telecom_hosts":
        return <HostTable />;
      case "hosts":
        return <HostsTable />;
      case "transactions":
        return <TransactionsTable />;
      case "owners":
        return <OwnerTable />;
      case "zoom":
        return <Zoom />;
      default:
        return <h1>Welcome</h1>;
    }
  };

  return (
    <div>
      <main>{renderContent()}</main>
    </div>
  );
};

export default React.memo(DContent);
